const situations = [
  'сотрудники работают только после напоминаний;',
  'инициативу проявляют единицы, остальные ждут указаний;',
  'руководителю приходится постоянно контролировать команду;',
  'сотрудники избегают ответственности за результат;',
  'задачи выполняются формально, без включённости в результат;',
  'сильные сотрудники перегружаются, а остальные остаются в стороне;',
  'сотрудники не понимают, зачем нужна поставленная задача;',
  'команда ждёт указаний вместо самостоятельных решений;',
  'руководитель использует преимущественно критику и контроль;',
  'достижения сотрудников остаются незамеченными;',
  'конфликты влияют на работу и отнимают ресурсы;',
  'сотрудники не видят возможностей развития;',
  'руководитель не умеет проводить сложные разговоры;',
  'команда хорошо работает только при непосредственном присутствии руководителя.',
];

export default function WhenProblemIsManagement() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему команда теряет мотивацию
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Если вы узнаёте свою ситуацию в списке ниже, проблема, скорее всего, не в «ленивых» сотрудниках, а в управленческой системе
        </p>

        <div className="grid sm:grid-cols-2 gap-3 mb-12">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-alert-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Иногда проблема мотивации — это не проблема сотрудников, а следствие управленческой системы.
          </p>
        </div>
      </div>
    </section>
  );
}